<template>
  <mdb-container>
    <EditAdvertisement
      :default-marker="marker"
      :ismobilepayspecific="ismobilepayspecific"
    />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditAdvertisement from "@/components/EditAdvertisement.vue";

export default {
  name: "AddAdvertisement",
  components: {
    mdbContainer,
    EditAdvertisement
  },
  props: {
    ismobilepayspecific: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      marker: {
        name: "Helsinki",
        position: { lat: 60.1733244, lng: 24.9410248 },
        radius: 0
      }
    };
  }
};
</script>

<style>
    
</style>